import { Component, OnInit, ChangeDetectorRef, OnDestroy, Input } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../../../store';
import { Observable, combineLatest } from 'rxjs';
import { takeWhile } from 'rxjs/operators';

import { MilesSliderControlComponent } from './miles-slider-control.component';
import { INDRALoginModalComponent } from '@ibe.components/shared/login-modal/login-modal.indra.component';
import { ScreenService, ModalService, SidebarService } from '@ibe/services/ui';
import { INDRAMilesService } from '@ibe.services/miles.indra.service';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { PaymentService } from '@ibe.components/shared/payment/payment.service';
import * as BookedTripActions from '@ibe/store/actions/booked-trip.actions';
import * as FlightsFilterActions from '@ibe/store/actions/flights-filter.actions';
import * as MilesBarActions from '@ibe/store/actions/miles-bar.actions';
import * as AncillariesWithMilesActions from '@ibe/store/actions/ancillaries-with-miles.actions';
import { INDRAPrice } from '@ibe.models/booking.fare.indra.model.lib';

import {
	UPGRADE_ACCOUNT_SIDEBAR_SOURCE_SLIDER_AND_EXTRAS
}
	from '@ibe.config';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
import { INDRATotalFlightPrice } from '@ibe.models/flight-price.model.indra.lib';



@Component({
	selector: 'app-miles-slider-control',
	templateUrl: './miles-slider-control.indra.component.html',
	styleUrls: ['./miles-slider-control.component.scss']
})
export class INDRAMilesSliderControlComponent extends MilesSliderControlComponent implements OnInit, OnDestroy {

	@Input()
	variation = null;
	@Input() bookAwardFlights: boolean;

	userInfo$: Observable<any> = this.store.select(fromStore.getUserInfo);
	hasLogin: boolean = false;
	userMiles: number = null;
	isUserMGPClient: boolean = false;

	maxIndicator = { cash: 0, miles: 0 };
	showMaxIndicatorCash: boolean = false;
	maxStep = { cash: 0, miles: 0 };
	minStep = 0;
	dummySteps = 3;

	currency: string;

	flightWithMiles$: Observable<boolean> = this.store.select(fromStore.getFlightsFilterFlightWithMiles);
	flightWithMiles: boolean;
	bookedTripDiscounts$: Observable<any> = this.store.select(fromStore.getSelectedBookedTripDiscounts);
	bookedTripDiscounts: Array<any> = [];
	milesDiscount$: Observable<INDRAPrice> = this.store.select(fromStore.getMilesBarDiscountInformationMiles);

	hasPromo: boolean = false;
	promoMiles = { value: 0, discount: 0 };

	formRange: FormGroup = new FormGroup({ sliderControl: new FormControl(null) });
	stepJump = 0;
	availableSteps = []; // Desktop slider
	milesOptions = []; // Mobile selectbox

	milesInFlightDiscount$: Observable<any> = this.store.select(fromStore.getMilesInFlightDiscount);
	milesInFlightDiscount: any;
	ancillaryTotalToPay$: Observable<any> = this.store.select(fromStore.getAncillaryTotalToPay);

	hasChanges$: Observable<any> = combineLatest([this.userInfo$, this.ancillaryTotalToPay$, this.milesService.conversionRates$]);

	private timeToThink_to_booking$: Observable<Object> = this.store.select(fromStore.getSelectedBookedTripTTTCompletionDetails);
	isTTTBookingPayment: boolean = false;

	isMobile: boolean = false;
	isIE = /*@cc_on!@*/false || !!document['documentMode'];
	isAlive: boolean = true;
	isLoading: boolean = true;
	hasRates: boolean = false;

	disabledSlider: boolean = false;
	private disabledSlider$: Observable<boolean> = this.store.select(fromStore.getAncillaryToPayWithMilesLoading);

	loadingTimeout;
	loaderTimeout;

	previousSliderValue = 0;
	milesAllowance: number;
	initialAvailableSteps: any;

	triggerUseMiles$: Observable<boolean> = this.milesService.triggerUseMiles$;

	totalFlightPrice: INDRATotalFlightPrice;

	constructor(
		private modalService: ModalService,
		private screen: ScreenService,
		private store: Store<fromStore.State>,
		private sidebarService: SidebarService,
		private cd: ChangeDetectorRef,
		private milesService: INDRAMilesService,
		private currencyService: INDRACurrencyService,
		private paymentInfoService: PaymentService,
		private router: Router,
		private ibeAdminConfigService: INDRAIbeAdminConfigService
	) {
		super();
		this.currency = this.currencyService.INDRA_getCurrencySymbol().unit;

		this.INDRA_getMilesAllowance();

		this.screen.isMobile().subscribe(value => {
			this.isMobile = value;
		});

		this.bookedTripDiscounts$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(discounts => {
				this.bookedTripDiscounts = Object.assign([], discounts);
			});

		this.flightWithMiles$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(flightWithMiles => {
				this.flightWithMiles = flightWithMiles;
			});

		this.milesDiscount$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value.cash && value.miles) {
					this.promoMiles.discount = value.cash;
					this.promoMiles.value = value.miles;
					this.hasPromo = true;
				} else {
					this.hasPromo = false;
				}
			});

		this.hasChanges$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(([userInfo, ancillaryTotalToPay]) => {
				if (userInfo) {
					this.hasLogin = true;
					this.userMiles = userInfo['currentPoints'] ? userInfo['currentPoints'] : 0;
					this.isUserMGPClient = userInfo['ffLevel'] ? true : false;
					this.maxIndicator.miles = ancillaryTotalToPay ? this.userMiles - ancillaryTotalToPay.miles : this.userMiles;
					this.showMaxIndicatorCash = false;

					if (this.INDRA_isTesteSetMilesPoint()) {
						if(this.availableSteps && this.availableSteps.length) {
							this.INDRA_setSliderControlToMax();
						}
					}
					else {
						this.INDRA_updateMiles(true);
					}
				} else {
					this.hasLogin = false;
					this.isUserMGPClient = false;
				}

				this.INDRA_generateValues();

				if (this.INDRA_isTesteSetMilesPoint()) {
					if(this.availableSteps && this.availableSteps.length) {
						this.INDRA_setSliderControlToMax();
					}
				}
			});

		this.milesInFlightDiscount$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					if (this.INDRA_isTesteSetMilesPoint()) {
						this.INDRA_setSliderControlToMax();
					}
					else {
						this.milesInFlightDiscount = value;
						const initialDiscount = this.availableSteps.find(step => step.value === value.miles);
						this.formRange.controls['sliderControl'].setValue(initialDiscount ? initialDiscount.value : this.INDRA_getLeastStepMiles());
					}

				} else {
					this.formRange.controls['sliderControl'].setValue(0);
					this.INDRA_updateMiles(true);
				}
			});

		this.disabledSlider$.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.disabledSlider = value;
				this.cd.markForCheck();
			});
		
		// get booking total cost
		this.paymentInfoService.totalFlightPrice
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(totalFlightPrice => {
				this.totalFlightPrice = totalFlightPrice;
			});

		/* 
		// TODO implement this with actual logic (from sprint 8 merge) -- this is used supposedly to set the slider to the 
		// 'saved' initial mgp discount when TTT for the booking was availed previously
		this.timeToThink_to_booking$.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					this.isTTTBookingPayment = true;
					this.formRange.controls['sliderControl'].setValue(this.promoMiles.value);
					this.milesSelected = this.promoMiles.value;
					this.store.dispatch(new AncillariesWithMilesActions.PutFlightMilesDiscountAction(this.milesSelected));
				}
			});
		*/

      this.triggerUseMiles$
      .pipe(takeWhile(() => this.isAlive))
      .subscribe(value => {
        if(value) {
          if (this.hasPromo) {
            if (!(this.hasLogin && this.userMiles < this.promoMiles.value)) {
              this.INDRA_updateMiles();
            }
          }
        }
      });
  }

	ngOnInit() {

		clearTimeout(this.loadingTimeout);  // to prevent style issues
		this.loadingTimeout = setTimeout(() => {
			this.isLoading = false;
		}, 500);

	}

	ngOnDestroy(): void {
		this.isAlive = false;
	}

	// ----------------------- START SLIDER PROCESSES -------------------------------//

	INDRA_generateValues() {
		this.milesOptions = [{ value: 0, label: `0 M | ${this.currencyService.INDRA_formatCash(0)} ` + this.currency }];
		this.availableSteps = [{ value: 0, discount: '0' }];

		if (this.hasPromo && ((this.hasLogin && this.isUserMGPClient && this.maxIndicator.miles >= this.minStep) || (!this.hasLogin))) {
			this.milesOptions.push({ value: this.promoMiles.value, label: 'Promo ' + this.promoMiles.value + ' M | ' + this.currencyService.INDRA_formatCash(this.promoMiles.discount) + ' ' + this.currency });
			this.availableSteps.push({ value: this.promoMiles.value, discount: this.promoMiles.discount, legend: '' });
			if (this.hasLogin) {
				this.minStep = this.promoMiles.value;
				this.initialAvailableSteps = this.availableSteps;
				if (this.userMiles < this.minStep) {
					let deficitMiles = this.minStep - this.userMiles;
					if (deficitMiles <= this.milesAllowance) {
					this.formRange.controls['sliderControl'].setValue(this.minStep);
					}else{
						this.formRange.controls['sliderControl'].setValue(0);
						this.INDRA_updateMiles();
					}
				}
			} else {
				this.minStep = 0;
			}
		}

		this.hasRates = false;
		const conversionRates: Array<any> = this.milesService.conversionRates;
		conversionRates.forEach(rate => {
			if (rate.valueCash) {
				if (this.hasLogin && this.isUserMGPClient && rate.miles > this.promoMiles.value) {
					this.hasRates = true;
					this.milesOptions.push({ value: rate.miles, label: rate.miles + ' M | ' + this.currencyService.INDRA_formatCash(rate.valueCash) + ' ' + this.currency });
					this.availableSteps.push({ value: rate.miles, discount: rate.valueCash });
				}
			}
		});
	}

	INDRA_getDiscountValue(cash) {
		return this.hasPromo ? cash + this.promoMiles.discount : cash;
	}

	INDRA_getMilesAllowance() {
		let milesAllowanceConfig = this.ibeAdminConfigService.getConfigurationValue('bookingPayment.initialMilesAllowance');
		this.milesAllowance = milesAllowanceConfig && !isNaN(parseFloat(milesAllowanceConfig)) ? Number(milesAllowanceConfig) : 1800;
	}

	INDRA_hasMilesAllowance(userMiles, minStep) {
		if (this.bookAwardFlights) {
			return (userMiles < minStep);
		} else {
			if (userMiles >= 0) {
				if (userMiles < minStep) {
					let deficitMiles = minStep - userMiles;
					if (deficitMiles <= this.milesAllowance) {
						this.userMiles = this.milesAllowance;
						this.availableSteps = this.initialAvailableSteps;
						this.formRange.controls['sliderControl'].setValue(this.milesInFlightDiscount.miles);

						return false;
					} else {
						return true;
					}
				} else {
					return false;
				}
			} else {
				return true;
			}
		}
	}


	async INDRA_updateMiles(manualUserChange?) {
		this.store.dispatch(new AncillariesWithMilesActions.PutLoadingAction(true)); // turn on loader
		let sliderValue = parseFloat(this.formRange.controls['sliderControl'].value);
		let flightDiscount = this.availableSteps.find(step => step.value === sliderValue);
		// if no login user or user is non-MGP and discount is greater than 0 do not call useMiles API
		const isMilesDiscountInValid = (!this.hasLogin || !this.isUserMGPClient) && +flightDiscount.discount > 0
		// call api to store flight miles spent
		if (flightDiscount && !isMilesDiscountInValid) { // && (this.milesService.oldMilesValue !== sliderValue)
			try {
				this.milesService.INDRA_updateMiles(+flightDiscount.discount).subscribe(data => {
					if (data.errors.length == 0) {
						this.previousSliderValue = sliderValue;
						this.milesService.oldMilesValue = sliderValue;
						this.formRange.controls['sliderControl'].setValue(sliderValue);
					} else {
						if (data.errors.filter(error => error.code == '400').length) {
							sliderValue = 0;
							this.formRange.controls['sliderControl'].setValue(sliderValue);
							this.previousSliderValue = sliderValue;
							this.milesService.oldMilesValue = sliderValue;
							flightDiscount.discount = 0;
							flightDiscount.value = 0;
						}
					}
					this.INDRA_triggerBookingTotalsUpdate(manualUserChange);
					this.INDRA_triggerCheckPaymentMethods();
				});
			} catch (error) {
				this.INDRA_triggerBookingTotalsUpdate(manualUserChange);
				this.INDRA_triggerCheckPaymentMethods();
				// reset sliderControl and flight discount to previous value to prevent checksum errors 
				// (ie since api failed on the backend, it is assumed that the backend still has the previous miles discount value set
				// thus frontend must also keep the previous miles discount value instead of the current/new one)
				this.formRange.controls['sliderControl'].setValue(this.previousSliderValue);
				flightDiscount = this.availableSteps.find(step => step.value === this.previousSliderValue);
			}
		}

		if(flightDiscount) {
			this.store.dispatch(new AncillariesWithMilesActions.PutFlightMilesDiscountAction({ cash: flightDiscount.discount, miles: flightDiscount.value }));

			// apply / reapply mgp discount depending on miles selected by user
			if (+flightDiscount.discount < this.promoMiles.discount || !this.promoMiles.value) {
				if (this.bookedTripDiscounts.find(cur => cur.id == 'mile-go')) {
					this.store.dispatch(new FlightsFilterActions.PutFlightWithMiles(false));
					this.store.dispatch(new MilesBarActions.SetDiscount(0));
					const newArray = this.bookedTripDiscounts.filter(discounts => discounts.id !== 'mile-go');
					this.store.dispatch(new BookedTripActions.PutBookedTripDiscountsAction(newArray));
				}
			} else {
				if (!this.bookedTripDiscounts.find(cur => cur.id == 'mile-go')) {
					this.store.dispatch(new FlightsFilterActions.PutFlightWithMiles(true));
					this.store.dispatch(new MilesBarActions.SetDiscount(this.promoMiles.discount));
					this.bookedTripDiscounts.push({ id: 'mile-go', value: this.promoMiles.discount, label: 'Miles&go promo 400 miles' });
					this.store.dispatch(new BookedTripActions.PutBookedTripDiscountsAction(this.bookedTripDiscounts));
				}
			}
		}
		// fix overlapping mgp logo
		if (this.hasPromo) {
			const steps = this.availableSteps.slice();
			const selectedStep = steps.find(step => step.value === this.promoMiles.value);
			if (selectedStep) sliderValue === this.promoMiles.value ? selectedStep.legend = '' : selectedStep.legend = '<div class="is-promo"></div>';
			this.availableSteps = steps;
		}

		clearTimeout(this.loaderTimeout);
		this.loaderTimeout = setTimeout(() => {
			this.store.dispatch(new AncillariesWithMilesActions.PutLoadingAction(false)); // turn off loader
		}, 1500);
	}

	INDRA_changeMiles(value) {
		this.formRange.controls['sliderControl'].setValue(value);
		this.INDRA_updateMiles(true);
	}

	INDRA_getLeastStepMiles() {
		const nextStep = this.availableSteps.find(step => step.value > 0);
		return nextStep ? nextStep.value : 0;
	}

	// ----------------------- END SLIDER PROCESSES -------------------------------//

	INDRA_handleLogin() {
		this.modalService.assignComponent(INDRALoginModalComponent);
		this.modalService.open();
	}

	INDRA_handleNewAccount() {
		this.sidebarService.openSidebar(['sign-up']);
	}

	INDRA_openUpgradeAccount() {
		this.sidebarService.openSidebar(['upgrade-miles-and-go'], [{ source: UPGRADE_ACCOUNT_SIDEBAR_SOURCE_SLIDER_AND_EXTRAS }]);
	}

	INDRA_triggerBookingTotalsUpdate(manualUserChange) {
		// only trigger booking total update when the user manually changed the slider or logs out while in review page
		if (manualUserChange && this.router.url.includes('review-your-trip')) {
			this.paymentInfoService.setUpdateBookingTotals(true);
		}
	}

	INDRA_triggerCheckPaymentMethods() {
		// only trigger checkPaymentMethods when the user is in payment page
		if (this.router.url.includes('payment')) {
			this.paymentInfoService.setTriggerCheckPaymentMethods(true);
		}
	}

	INDRA_isTesteSetMilesPoint(): boolean {
		return parseFloat(sessionStorage.getItem('teste-setMilesPoint')) === 1
	}

	INDRA_setSliderControlToMax() {
		if(this.availableSteps && this.availableSteps.length) {
			this.formRange.controls['sliderControl'].setValue(this.availableSteps[this.availableSteps.length - 1].value);
		}
	}
}
